import axios from '../../axios';
import {
   DELETE_OVER_ADJUSTED,
   DELETE_EXTRA_OVER_ADJUSTED,
} from '../types';
import { toast } from 'react-toastify';


export const deleteOverAdjusted = () => async (dispatch) => {
   try {
      const res = await axios.post(`/outAdjustment/delete/overAdjusted`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_OVER_ADJUSTED, payload:  res.data  });
         // toast.success('overAdjusted deleted successfully!');
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to delete Customer. Please try again.');
   }
};

export const deleteExtraOutAdj = () => async (dispatch) => {
   try {
      const res = await axios.post(`/outAdjustment/delete/extraOutAdj`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_EXTRA_OVER_ADJUSTED, payload: { res } });
         // toast.success('extraOutAdj deleted successfully!');
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to delete Customer. Please try again.');
   }
};

